import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule, RequestOptions, Http } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import * as Sentry from '@sentry/browser';

class SentryErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    Sentry.captureException(err.originalError || err);
    console.error(err);
  }
}
import { ToastModule, ToastOptions } from 'ng2-toastr';
import { Ng2TableModule } from 'ng2-table';
import { SelectModule } from 'ng2-select';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { TreeModule } from 'angular-tree-component';

// Store
import { StoreModule } from '@ngrx/store';
import { userReducer } from './store/reducers/user.reducer';

// Application routing module
import { routing } from './app.routing';

import { AuthenticationService } from './_services/index';
import { AdminService } from './_services/admin.service';
import { AppService } from './app.service';
import { OidcService } from './auth/oidc.service';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { DrilldownComponent } from './drilldown/drilldown.component';
import { FamiliesEditComponent } from './families/edit/edit.component';
import { DriverComponent } from './drivers/driver/driver.component';
import { ModuleComponent } from './modules/module/module.component';
import { BridgeComponent } from './bridges/bridge/bridge.component';
import { SensorComponent} from './sensors/sensor/sensor.component';
import { SensorAccessoryComponent} from './sensor_accessories/sensor_accessory/sensor_accessory.component';
import { VisibilityComponent } from './_component/visibility/visibility.component';
import { ViewStatusComponent } from './_component/viewstatus/viewstatus.component';
import { BatchDeleteComponent } from './_component/delete/delete.component';
import { ConfirmFlushComponent } from './_component/confirm/confirm.component';
import { CheckboxComponent } from './_component/checkbox/checkbox.component';
import { RadioComponent } from './_component/radio/radio.component';
import { ImageUploadComponent } from './_component/imageupload/imageupload.component';
import { WhitelistingComponent } from './management/components/whitelisting/whitelist.component';
import { DrilldownListComponent } from './drilldown/list/list.component';
import { DrilldownService } from './_services/drilldown.service';
import { BatchEditModulesComponent } from './batch/modules/edit.component';
import { BatchEditDriversComponent } from './batch/drivers/edit.component';
import { BatchEditBridgesComponent } from './batch/bridges/edit.component';
import { BatchEditSensorsComponent } from './batch/sensors/edit.component';
import { BatchEditSensorAccessoriesComponent } from './batch/sensor-accessories/edit.component';
import { WhitelistComponent } from './_component/whitelist/whitelist.component';
import { authHttpServiceFactory} from './_modules/auth.module';
import { GenericsearchComponent } from './genericsearch/genericsearch.component';
import { ManagementComponent } from './management/management.component';
import { TagsDrilldownComponent } from './tags-drilldown/tags-drilldown.component';
import { TagComponent } from './tags-drilldown/tag/tag.component';
import { CccComponent } from './ccc/ccc.component';
import { CustomToastOptions} from './_custom/toast-options';
import { SearchresultComponent } from './_component/searchresult/searchresult.component';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { FlushComponent} from './management/components/flush/flush.component';
import { UploadComponent} from './management/components/csvupload/upload.component';
import { CatalogComponent} from './management/components/catalog/catalog.component';
import { ImpersonateComponent} from './management/components/impersonate/impersonate.component';
import { ManageportfolioComponent } from './management/components/manageportfolio/manageportfolio.component';
import { UnauthorizedComponent} from './unauthorized/unauthorized.component';
import { AuthConfig, AuthHttp} from 'angular2-jwt';
import { AdminComponent} from './admin/admin.component';
import { Permissions } from './_services/permissions';
import { UserexportComponent } from './management/components/userexport/userexport.component';
import { RoleexportComponent } from './management/components/roleexport/roleexport.component';
import { FamilyLabelsComponent } from './management/components/familylabels/familylabels.component';
import { OidcAuthenticateComponent } from './auth/oidc_authenticate.component';
import { OidcSilentAuthenticateComponent } from './auth/oidc_silent_authenticate.component';

const toastOptions = {
  enableHTML: true
};

@NgModule({
  imports: [
    BrowserModule,
    StoreModule.forRoot({ user: userReducer }),
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    Ng2TableModule,
    ToastModule.forRoot(),
    SelectModule,
    TreeModule,
    HttpClientModule,
    routing
  ],
  declarations: [
    OidcAuthenticateComponent,
    OidcSilentAuthenticateComponent,
    AppComponent,
    HeaderComponent,
    LoginComponent,
    ManagementComponent,
    TagsDrilldownComponent,
    TagComponent,
    CccComponent,
    AdminComponent,
    LogoutComponent,
    GenericsearchComponent,
    UnauthorizedComponent,
    DrilldownComponent,
    DrilldownListComponent,
    VisibilityComponent,
    ViewStatusComponent,
    CheckboxComponent,
    RadioComponent,
    ImageUploadComponent,
    BatchDeleteComponent,
    ConfirmFlushComponent,
    FamiliesEditComponent,
    WhitelistingComponent,
    DriverComponent,
    ModuleComponent,
    BridgeComponent,
    SensorComponent,
    SensorAccessoryComponent,
    BatchEditModulesComponent,
    BatchEditDriversComponent,
    BatchEditBridgesComponent,
    BatchEditSensorsComponent,
    BatchEditSensorAccessoriesComponent,
    WhitelistComponent,
    SearchresultComponent,
    FlushComponent,
    UploadComponent,
    CatalogComponent,
    ImpersonateComponent,
    ManageportfolioComponent,
    UserexportComponent,
    RoleexportComponent,
    FamilyLabelsComponent
  ],
  providers: [
    OidcService,
    AuthenticationService,
    AppService,
    AdminService,
    DrilldownService,
    Permissions,
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: ToastOptions, useClass: CustomToastOptions },
    { provide: ErrorHandler, useClass: SentryErrorHandler },
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts